export default "__VITE_ASSET__DEn4pLiz__"